import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import {
  createSearchStatement,
  FUNCTION_RESULT_STATUS,
  ICustomer,
} from "@nova/common-interfaces";
import { IInvoice } from "@rfm/shared-interfaces";
import { BlockUIModule } from "ng-block-ui";
import { MenuItem } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { MenuModule } from "primeng/menu";
import { SelectButtonModule } from "primeng/selectbutton";
import { TableModule } from "primeng/table";
import { TabMenuModule } from "primeng/tabmenu";
import { CommonComponent } from "../../../../../../lib/components/index.mjs";
import { InvoiceService } from "../../../../../shared/services/financial/invoice.service.mjs";

@Component({
  selector: "app-invoice-list",
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    BlockUIModule,
    MenuModule,
    TabMenuModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectButtonModule,
  ],
  templateUrl: "./invoice-list.component.html",
  styleUrls: ["./invoice-list.component.scss"],
})
export class InvoiceListComponent extends CommonComponent implements OnInit {
  invoices: IInvoice[] = [];
  filtered_invoices: IInvoice[] = [];
  activeItem: IInvoice | undefined;
  activeTab: any;

  tabs: MenuItem[] = [
    { label: "All", command: () => this.setActiveTab("All") },
    { label: "Paid", command: () => this.setActiveTab("Paid") },
    { label: "Pending", command: () => this.setActiveTab("Pending") },
    { label: "Outstanding", command: () => this.setActiveTab("Outstanding") },
    { label: "Cancelled", command: () => this.setActiveTab("Cancelled") },
  ];

  addInvoice() {
    this.router.navigateByUrl('/admin/invoices/edit/' + 0);
  }
  
  setActiveTab(label: string) {
    this.activeTab = label;

    switch (label.toLowerCase()) {
      case "all":
        this.filtered_invoices = this.invoices.filter(
          (x) => x.is_deleted !== true
        );
        break;
      case "paid":
        this.filtered_invoices = this.invoices.filter(
          (x) => x.status === "PAID" && x.is_deleted !== true
        );
        break;
      case "pending":
        this.filtered_invoices = this.invoices.filter(
          (x) => x.status === "Pending" && x.is_deleted !== true
        );
        break;
      case "cancelled":
        this.filtered_invoices = this.invoices.filter(
          (x) => x.is_deleted === true
        );
        break;
      case "outstanding":
        this.filtered_invoices = this.invoices.filter(
          (x) => x.status !== "PAID" && x.is_deleted !== true
        );
        break;
    }
  }

  items: MenuItem[] = [
    {
      label: "View",
      icon: "pi pi-file",
      command: () => this.view(this.activeItem!.id),
    },
    {
      label: "Edit",
      icon: "pi pi-file-edit",
      command: () => this.edit(this.activeItem!.id),
    },
    {
      label: "View Customer",
      icon: "pi pi-share-alt",
      command: () => this.showAll(this.activeItem!.customer!.id),
    },
  ];
  view(invoice_id: string) {
    this.router.navigateByUrl("/admin/invoices/view/" + invoice_id);
  }

  edit(invoice_id: string) {
    this.router.navigateByUrl("/admin/invoices/edit/" + invoice_id);
  }

  showAll(customer_id: string) {
    this.router.navigateByUrl("/admin/customers/view/" + customer_id);
  }

  constructor(
    protected router: Router,
    protected invoiceService: InvoiceService
  ) {
    super();
    this.isLoading(true);
  }

  selectedInvoice: IInvoice | undefined;

  rowSelected() {
    console.log("Invoice", this.selectedInvoice);
    this.router.navigate(["/admin/invoices/view/", this.selectedInvoice?.id]);
  }

  getGaiiaData(customer: ICustomer) {
    let result = "";

    if (customer.reference_keys && customer.reference_keys.length > 0) {
      result = customer.reference_keys.data[0].referenceId;
    }

    return result;
  }

  ngOnInit() {
    this.invoiceService
      .getAll(createSearchStatement("createdAt > 1705294800000"))
      .then((result) => {
        if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
          this.invoices = result.data!;
          this.setActiveTab("all");
        }
      })
      .finally(() => {
        this.isLoading(false);
      });
  }
}
